module.exports = __webpack_public_path__ + "img/adminLogo.355ed88f.svg";